// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_receiving_ui_styles" + "." + "d2764844" + ".chunk.css";
};